import { useApi } from './use-api-call';
import { AccessTeamDTO } from './access-team-api';
import { UserDTO } from './user-api';


export const useSearchAccessTeamUserApi = () => useApi<{ 
accessTeamUsers: AccessTeamUserDTO[];
        accessTeams: AccessTeamDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/access-team-user/search-access-team-user');

export const useGetAccessTeamUserApi = () => useApi<{ accessTeamUser: AccessTeamUserDTO; allowEdit: boolean; }>('/access-team-user/get-access-team-user/{accessTeamSerial}/{userName}');

export const useSaveAccessTeamUserApi = () => useApi<{ accessTeamUser: AccessTeamUserDTO}>('/access-team-user/save-access-team-user');

export const useDeleteAccessTeamUserApi = () => useApi('/access-team-user/delete-access-team-user/{accessTeamSerial}/{userName}');

export interface AccessTeamUserDTO { 
accessTeamSerial:number;
userName:string;
}
